export default {
  root: '/pricing',
  communications: '/pricing/communications',
  vault: '/pricing/vault',
  transfer: '/pricing/transfer',
} as const;
